<!--Card-->
<div class="card testimonial-card" [style]="cardStyles">
  <!--Background color-->
  @if (cardBannerClasses) {
    <div [class]="cardBannerClasses">
      <!--Avatar-->
      <div class="avatar mx-auto">
        <img
          [src]="imgUrl ? imgUrl : (image() | imageUrl)"
          class="rounded-circle img-responsive"
          />
        </div>
      </div>
    }


    <div class="card-body">
      <!--Name-->
      <h4 class="card-title title-text">
        @if (!nameClickable) {
          <span>{{ name }}</span>
        }
        @if (nameClickable) {
          <a class="title-link" (click)="doNameClick()">{{
            name
          }}</a>
        }
      </h4>
      <p class="text-muted">{{ subtitle }}</p>
      <hr />
      <!--Quotation-->
      <p class="card-text pt-2">
        {{ bodyText }}
      </p>
    </div>
  </div>
  <!--/.Card-->
